import React, { useEffect, useState } from "react";
import "./index.less";
import selectClose from "@/assets/landing/selectClose.png";

const AddressModal = (prop) => {
  const { isMobile = true, value = null, address, addObjs = null } = prop;
  const [list, setList] = useState([]);
  const [list1, setList1] = useState([]);
  const [list2, setList2] = useState([]);
  const [list3, setList3] = useState([]);
  const [currentIdx, setCurrentIdx] = useState(0);
  const [addrRegion, setAddrRegion] = useState({ desc: "Choose Region" });
  const [addrProvince, setAddrProvince] = useState({ desc: "Choose Province" });
  const [addrCity, setAddrCity] = useState({ desc: "Choose City" });
  const [stepObj, setStepObj] = useState({});
  const title = "Current address";
  useEffect(() => {
    if (addObjs) {
      setAddrRegion(addObjs.addrRegion || { desc: "Choose Region" });
      setAddrProvince(addObjs.addrProvince || { desc: "Choose Province" });
      setAddrCity(addObjs.addrCity || { desc: "Choose City" });
      setStepObj(addObjs.addrCity);
      initList(-1, addObjs);
    } else {
      initList();
    }

    return () => {
      setList([]);
    };
  }, address);
  const initList = (cIdx = 0, value = null) => {
    let temp1 = [];
    let temp2 = [];
    let temp3 = [];
    let addrRegionTemp = {};
    let addrProvinceTemp = {};
    if (value) {
      addrRegionTemp = value.addrRegion;
      addrProvinceTemp = value.addrProvince || {};
    }
    console.log("addrRegionTemp", addrRegionTemp, addrProvinceTemp);
    address.forEach((item) => {
      let addrRegionInfo = {
        value: item.value,
        label: item.label,
      };
      temp1.push(addrRegionInfo);
      if (addrRegionTemp.value) {
        if (item.value === addrRegionTemp.value) {
          let children = item.children;
          children.forEach((province) => {
            addrRegionInfo = {
              value: province.value,
              label: province.label,
            };
            temp2.push(addrRegionInfo);
            if (addrProvinceTemp.value) {
              if (province.value === addrProvinceTemp.value) {
                let children1 = province.children;
                children1.forEach((city) => {
                  addrRegionInfo = {
                    value: city.value,
                    label: city.label,
                  };
                  temp3.push(addrRegionInfo);
                });
              }
            }
          });
        }
      }
    });

    switch (cIdx) {
      case 0:
        setList(temp1);
        setList1(temp1);
        break;
      case 1:
        setList(temp2);
        setList2(temp2);
        break;
      case 2:
        setList(temp3);
        setList3(temp3);
        break;
      case -1:
        setList1(temp1);
        setList2(temp2);
        setList3(temp3);
        setList(temp3);
        break;
      default:
        break;
    }
    setCurrentIdx(cIdx > -1 ? cIdx : 2);
  };
  const onTabSelect = (currentIdx) => {
    switch (currentIdx) {
      case 0:
        setStepObj(addrRegion);
        setList(list1);
        break;
      case 1:
        setStepObj(addrProvince);
        setList(list2);
        break;
      case 2:
        setStepObj(addrCity);
        setList(list3);
        break;
      default:
        break;
    }
    setCurrentIdx(currentIdx);
  };
  const onSelect = (item) => {
    setStepObj(item);

    let tempItem = {};
    let addrRegionTemp, addrProvinceTemp, addrCityTemp;
    switch (currentIdx) {
      case 0:
        setList([]);
        setList2([]);
        setList3([]);
        setAddrRegion({});
        setAddrProvince({ desc: addrProvince.desc });
        setAddrCity({ desc: addrCity.desc });
        addrRegionTemp = { ...addrRegion, ...item };
        setAddrRegion(addrRegionTemp);
        tempItem = { addrRegion: addrRegionTemp };
        break;
      case 1:
        setList([]);
        setList3([]);
        setAddrCity({ desc: addrCity.desc });
        setAddrProvince();
        addrRegionTemp = addrRegion;
        addrProvinceTemp = { ...addrProvince, ...item };
        setAddrProvince(addrProvinceTemp);
        tempItem = { addrRegion, addrProvince: addrProvinceTemp };
        break;
      case 2:
        setList3([]);
        addrRegionTemp = addrRegion;
        addrProvinceTemp = addrProvince;
        addrCityTemp = { ...addrCity, ...item };
        setAddrCity(addrCityTemp);

        break;
      default:
        break;
    }
    if (currentIdx < 2) {
      setTimeout(() => {
        initList(currentIdx + 1, tempItem);
      }, 200);
    } else {
      prop.onSelect &&
        prop.onSelect(
          { name: "addObjs" },
          {
            addrRegion: addrRegionTemp,
            addrProvince: addrProvinceTemp,
            addrCity: addrCityTemp,
          }
        );
    }
  };
  return (
    <div className={["aSelectModal", !isMobile && "aSelectModalPc"].join(" ")}>
      <div className={"asmInfo"}>
        <div className={"asmHeader"}>
          <div className={"asmTxt"}>{title}</div>
          <img
            onClick={() => prop.onSelect({ name: "addObjs" })}
            src={selectClose}
          />
        </div>
        <div className={"asmLine"}>
          <div
            className={["asmsLabel", !!addrRegion.label && "asmsLabelOn"].join(
              " "
            )}
            onClick={() => onTabSelect(0)}
          >
            {addrRegion.label || addrRegion.desc}
          </div>
          {!!addrRegion.label && (
            <div
              className={[
                "asmsLabel",
                !!addrProvince.label && "asmsLabelOn",
              ].join(" ")}
              onClick={() => onTabSelect(1)}
            >
              {addrProvince.label || addrProvince.desc}
            </div>
          )}
          {!!addrProvince.label && (
            <div
              className={["asmsLabel", !!addrCity.label && "asmsLabelOn"].join(
                " "
              )}
              onClick={() => onTabSelect(2)}
            >
              {addrCity.label || addrCity.desc}
            </div>
          )}
        </div>
        <div className={["asmList", "asmListAddress"].join(" ")}>
          {list &&
            list.length > 0 &&
            list.map((item) => (
              <div
                className={[
                  "asmItem",
                  stepObj.value && stepObj.value === item.value && "asmItemOn",
                ].join(" ")}
                onClick={() => onSelect(item)}
              >
                {item.label}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
export default AddressModal;
